export class DeviceType {
	name: string;
	measurements: Array<string> = new Array<string>();
	properties: any;
}

export class DeviceTypeProperty {
	id: string;
	name: string;
	value: string;
}